const normalize = (value) =>
  (value || '')
    .toString()
    .trim()
    .toUpperCase();

const mode = normalize(
  process.env.MODE ||
    process.env.REACT_APP_MODE ||
    process.env.REACT_APP_ENV ||
    process.env.NODE_ENV
);
const logFlag = normalize(process.env.REACT_APP_ENABLE_LOGS);

const allowedModes = new Set(['DEV', 'DEVELOPMENT']);
let shouldEnableLogs = allowedModes.has(mode);

if (logFlag === 'TRUE' || logFlag === 'YES' || logFlag === '1') {
  shouldEnableLogs = true;
} else if (logFlag === 'FALSE' || logFlag === 'NO' || logFlag === '0') {
  shouldEnableLogs = false;
}

const noop = () => {};
const originalConsole = {};

['log', 'info', 'debug', 'warn', 'error'].forEach((method) => {
  if (typeof console[method] !== 'function') {
    return;
  }

  originalConsole[method] = console[method].bind(console);
  console[method] = (...args) => {
    if (shouldEnableLogs) {
      originalConsole[method](...args);
    }
  };
});

export default shouldEnableLogs;
